import { useEffect, useState } from 'react';
import { Source, Layer, Popup, useMap } from 'react-map-gl/mapbox';
import { API_URL } from '../../../config';
import elderlyHomesIcon from '../../../assets/elderly-home.png';
import { authFetch } from '../../../utils';

const ElderlyHomesLayer = ({ visible }) => {
  const [geojsonData, setGeojsonData] = useState(null);
  const [popupInfo, setPopupInfo] = useState(null);
  const { current: map } = useMap();

  useEffect(() => {
    if (!map) return;

    // Verifica si el icono ya está cargado
    if (!map.hasImage('elderly-homes-icon')) {
      map.loadImage(elderlyHomesIcon, (error, image) => {
        if (error) {
          console.error('Error al cargar el icono:', error);
          return;
        }
        if (!map.hasImage('elderly-homes-icon')) {
          map.addImage('elderly-homes-icon', image);
        }
      });
    }
  }, [map]);

  useEffect(() => {
    if (!visible) return;

    authFetch(`${API_URL}emergency-layers/elderly-homes`)
      .then(res => res.json())
      .then(data => setGeojsonData(data))
      .catch(err => console.error('Error al cargar residencias de ancianos:', err));
  }, [visible]);

  useEffect(() => {
    if (!map || !geojsonData) return;

    const handleClick = e => {
      const features = map.queryRenderedFeatures(e.point, {
        layers: ['elderly-homes']
      });

      if (features.length > 0) {
        const feature = features[0];
        const coords = feature.geometry.coordinates;
        const props = feature.properties;

        setPopupInfo(null);

        setTimeout(() => {
          setPopupInfo({
            longitude: coords[0],
            latitude: coords[1],
            nombre: props.nombre,
          });
        }, 0);
      } else {
        setPopupInfo(null);
      }
    };

    map.on('click', handleClick);
    return () => map.off('click', handleClick);
  }, [map, geojsonData]);

  if (!visible || !geojsonData) return null;

  return (
    <>
      <Source id="elderly-homes" type="geojson" data={geojsonData}>
        <Layer
            id="elderly-homes"
            type="symbol"
            layout={{
                'icon-image': 'elderly-homes-icon',
                'icon-size': 0.25, // Ajusta el tamaño según lo que necesites
                'icon-offset': [0, -1],
                'icon-anchor': 'top',
                'icon-allow-overlap': true,
                'icon-ignore-placement': true
            }}
            />

      </Source>

      {popupInfo && (
        <Popup
          longitude={popupInfo.longitude}
          latitude={popupInfo.latitude}
          anchor="bottom"
          onClose={() => setPopupInfo(null)}
        >
          <div style={{ lineHeight: '1.4em' }}>
            <div>{popupInfo.nombre}</div>
          </div>
        </Popup>
      )}
    </>
  );
};

export default ElderlyHomesLayer;
